<script lang="ts" setup>
import type { Trial } from "~/types/layout";
import type { MenuItemProps } from "~/types/menus";

defineProps<{
	name: string;
	icon?: string;
	items: MenuItemProps[];
	trial?: Trial | null;
}>();
</script>

<template>
	<h3>
		<Icon
			v-if="icon"
			:icon="icon"
			width="18px"
		/>
		{{ translate(name) }}
	</h3>
	<TrialBox
		v-if="trial"
		:infos="trial"
	/>
	<ul>
		<li
			v-for="item in items"
			:key="item.name"
		>
			<Menu-Item
				v-if="item.visible ?? true"
				:item="item"
			/>
		</li>
	</ul>
</template>

<style lang="scss" scoped>
@use "@/assets/css/elements.scss";

h3 {
	@apply flex items-center gap-2 font-bold uppercase text-secondary;
	@extend %menu-shadow;
}

ul {
	@apply flex flex-col gap-1 mt-2;
}
</style>
